import { graphql } from 'src/graphql';

export const TokenLimitUpdatesSubscription = graphql(`
  subscription TokenLimitUpdates {
    tokenLimitUpdates {
      daily {
        allowed
        tokensUsed
        tokensRemaining
        windowResetTime
      }
    }
  }
`);
